export default "/images/vendor/flag-icon-css/flags/1x1/ee.svg?7b6b8abcf78cfa7f4a773de556859b2f";